	export enum EarSideExtendedUnspecifiedEnum {
		Right = 1,
		Left = 2,
		Binaural = 3,
		Unspecified = 4
	}
